import { useKeycloak } from "@/app/hook/use-keycloak";
import { LocalizationText } from "@/app/index";
import { Button } from "@/base/components/index";
import { cx } from "antd-style";
import { ButtonSigninProps } from "../types/index";
import { useButtonSigninStyles } from "./button-signin.styles";

export const ButtonSignin = ({
  children,
  className,
  size,
  block,
  ...buttonProps
}: ButtonSigninProps) => {
  const { styles } = useButtonSigninStyles();
  const keycloak = useKeycloak();

  const handleClick = () => {
    keycloak.login();
  };

  return (
    <Button
      color="green"
      variant="solid"
      size={size || "large"}
      block={block}
      className={cx(styles.root, className)}
      onClick={handleClick}
      {...buttonProps}
    >
      {children || <LocalizationText value="widget.button.signin.text" />}
    </Button>
  );
};
